import { FormControl, FormHelperText, InputLabel, MenuItem, Select } from '@mui/material';
import { Controller } from 'react-hook-form';

interface Props {
  label: string;
  items: any[];
  labelKey: string;
  valueKey: string;
  controllerProps: any;
  errors?: any;
  isReadOnly?: boolean;
  onChange?: (value: any) => void;
  isRequired?: boolean;
}

export function SelectBox({
  label,
  items,
  labelKey,
  valueKey,
  controllerProps,
  errors,
  isReadOnly,
  onChange,
  isRequired,
}: Props) {
  return (
    <FormControl fullWidth>
      <InputLabel required={isRequired}>{label}</InputLabel>
      <Controller
        {...controllerProps}
        render={({ field }) => (
          <>
            <Select
              required={isRequired}
              {...field}
              label={label}
              error={Boolean(errors[controllerProps.name])}
              disabled={isReadOnly}
              onChange={(e, data) => {
                field.onChange(data ? e.target.value : null);
                if (!onChange) return;
                onChange!(data ? e.target.value : null);
              }}
            >
              {items.map((item) => (
                <MenuItem key={item[valueKey]} value={item[valueKey]}>
                  {item[labelKey]}
                </MenuItem>
              ))}
            </Select>
            <FormHelperText error={Boolean(errors[controllerProps.name])}>
              {errors[controllerProps.name]?.message}
            </FormHelperText>
          </>
        )}
      />
    </FormControl>
  );
}
